import React from "react";
import { Layout } from "../../components/Layout";
import { CategorySidebar } from "../../components/sidebars/CategorySidebar";
import { GET_CATEGORY_PATHS, GET_CATEGORY_BY_SLUG, } from "../../mysql/queries/categories";
import { GET_BASE_INDEX } from "../../mysql/queries/index-page";
import { gamesPerPage } from "../../config";
import { Meta } from "../../components/Meta";
import { GET_POSTS_BY_CATEGORY_PAGINATED } from "../../mysql/queries/posts";
import { GameCategoryContent } from "../../components/GameCategoryContent";

export const getStaticPaths = async () => {
  const paths = [];
  const categories = await GET_CATEGORY_PATHS();
  categories.forEach((cat) => {
    paths.push({
      params: {
        slug: [cat.slug],
      }
    });

    const pages = Math.floor(cat.post_count / gamesPerPage) + 1;
    for (let i = 1; i <= pages; i++) {
      const pagedSlug = [cat.slug, "page", i.toString()];
      paths.push({
        params: {
          slug: pagedSlug
        }
      });
    }
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps = async ({ params }) => {
  const category = await GET_CATEGORY_BY_SLUG(params.slug[0]);
  const page = Number(params.slug[2] || 1);

  const posts = await GET_POSTS_BY_CATEGORY_PAGINATED(
    params.slug[0],
    gamesPerPage, //size
    (page - 1) * gamesPerPage //offset
  );

  const indexData = await GET_BASE_INDEX();

  return {
    props: {
      data: {
        currentPage: page,
        category: {
          ...category,
          posts
        },
        ...indexData,
      },
    },
  };
};

const CategoryPage = ({ data }) => {
  const title = "Category: " + data?.category?.name + " | Radcade";
  const description = data?.category?.name + "...";
  const url = `${data.settings[0].siteurl}/category/${data.category.slug}/`;

  return (
    <Layout data={data}>
      <Meta title={title} description={description} url={url} />
      <div className="responsive flex-col md:flex-row">
        <div className="flex-grow">
          <GameCategoryContent data={data} />
        </div>
        <div className="w-sidebar flex-shrink-0 md:ml-5">
          <CategorySidebar data={data} />
        </div>
      </div>
    </Layout>
  );
};

export default CategoryPage;
